import { alpha, styled, TextField } from '@mui/material';

import { RookeryRegularFont } from 'v3/styles/common';

export const TextFieldStyles = styled(TextField)(({ theme, fullWidth, error }) => ({
  width: fullWidth ? '100%' : '15rem',
  height: '3rem',
  justifyContent: 'center',
  border: 'none',
  borderBottom: `.1rem solid ${error ? theme.palette.error.main : theme.palette.secondary.light}`,

  input: {
    font: `400 1rem ${RookeryRegularFont}`,
    color: theme.palette.common.white,
    padding: '0',

    '&::placeholder': {
      color: alpha(theme.palette.common.white, 0.58),
    },

    '&::-webkit-inner-spin-button': {
      appearance: 'none',
    },

    '&::-webkit-outer-spin-button': {
      appearance: 'none',
    },

    MozAppearance: 'textfield',
  },

  fieldset: { border: 'none' },

  '& .MuiInputLabel-root.Mui-focused,& .MuiFormLabel-root': {
    color: `${alpha(theme.palette.common.white, 0.6)} `,
    left: '-0.88rem ',
  },

  '& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input': {
    WebkitTextFillColor: theme.palette.common.white,
  },

  '& .MuiInputBase-root': {
    padding: 0,
  },

  '& .MuiInputLabel-root.Mui-disabled': {
    color: theme.palette.secondary.light,
  },

  '&:is(:focus-within)': {
    borderBottom: 'double .2rem transparent',
    backgroundImage: `${theme.palette.gradient[500]}, ${theme.palette.gradient[100]}`,
    backgroundRepeat: 'no-repeat',
    backgroundOrigin: 'border-box',
    backgroundSize: '100% 9%',
    backgroundClip: 'padding-box, border-box',
    backgroundPosition: 'bottom',
  },
}));
